import type { FaireProductEntity } from "../../entity_types/product";

export const p_fm3wx9phj7: FaireProductEntity = {
  token: "p_fm3wx9phj7",
  type: "product",
  name: "Mindfulness Cards for Kids",
  brandToken: "b_14eeavl3ro",
  brandName: "Sourcebooks",
  imageUrl:
    "https://cdn.faire.com/fastly/cff73b15cf704d5da06b569e75333fdc4a73d523bedcf17a82faa7018d26ff87.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.76,
  description:
    "Help kids be more mindful every day—for ages 8 to 12  \rMindfulness is a healthy way for kids to take a pause and control their emotions when they’re feeling angry, upset, or overwhelmed. And just like playing a sport or learning a musical instrument, it’s a skill that they can build on. With these mindfulness cards for kids, your child will find easy ways to practice being present, feeling grateful, and finding the positive in every situation.  A variety of exercises—This set includes 60 simple activities for kids to try, including deep breathing, stretching, and focusing their thoughts on something happy.\r Short and sweet—Exercises feature simple instructions and only take about 10 minutes each, so it’s easy for kids to learn them and stick with them.\r Calm, Focus, Respond, and Reconnect—Kids will explore cards from 4 categories so they can target exactly what they’re feeling in the moment. They’ll even find tips for what time of day is best to try them!\r  \rGive kids the gift of mindf",
  tags: [],
  msrpDollars: 23.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:33.354Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
